import { push } from 'react-router-redux';
/* eslint-disable class-methods-use-this */
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import UserUtils from '../../../services/user-utils';
import generalCss from '../../styles/components/checkout-steps/payment/payment-method-selector.scss';
import kwalletCss from '../../styles/components/checkout-steps/payment/payment-method-k-wallet.scss';
import signInFormCss from '../../styles/pages/signin.scss';
import kwalletLogoImg from '../../../images/kwallet-logo.svg';
import SignInForm from '../../shared/sign-in-form';
import spreeStore from '../../../store';
import actions from '../../../actions';
import LoaderUtils from '../../../services/loader-utils';
import Loader from '../../shared/loader';
import WalletsAPI from '../../../apis/wallets';
import { priceFormat } from '../../../helper';
import APP_ROUTES from '../../../constants/app-routes';

class PaymentMethodKWallet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasKWalletAccountActive: false,
            balance: 0,
            availableBalance: 0,
        };
    }

    componentDidMount() {
        const checkKWalletAccount = async () => {
            const { wallets: { kwallet: hasKWalletAccountActive }, auth: { access_token: accessToken } } = spreeStore.getState();
            if (hasKWalletAccountActive) {
                const response = await WalletsAPI.getWalletDetails({ wallet: 'kwallet', token: accessToken });
                const { body: { balance, available_balance: availableBalance } } = response;
                this.setState({ balance, availableBalance, hasKWalletAccountActive });
            }
        };
        if (UserUtils.isLoggedIn()) {
            checkKWalletAccount();
        }
    }

    onNext() {
        if (!spreeStore.getState().order.isFinalStepHappening && !LoaderUtils.isLoading()) {
            spreeStore.dispatch(actions.setIsFinalStepHappening(true));
            spreeStore.dispatch(actions.displayLoader());
            window.scrollTo(0, 0);

            const onCompleteError = (error) => {
                this.sendDataPaymentMethod();
            };

            spreeStore.dispatch(actions.goToNextStep(this.props.order, this.props.locale, {}, true, { onCompleteError })).then(
                () => { },
                (error) => {
                    console.log(error);
                },
            ).finally(() => {
                spreeStore.dispatch(actions.setIsFinalStepHappening(false));
                spreeStore.dispatch(actions.hideLoader());
            });
        }
    }

    onSignIn(formData) {
        UserUtils.signUp(formData, this.props.locale, false).then(() => {
            const { auth: { access_token: accessToken } } = spreeStore.getState();
            spreeStore.dispatch(actions.activeWallet('kwallet', accessToken, true)).then((result) => {
                if (result) {
                    WalletsAPI.getWalletDetails({ wallet: 'kwallet', token: accessToken }).then((response) => {
                        console.log('response', response);
                        const { body: { balance, available_balance: availableBalance } } = response;
                        this.setState({ balance, availableBalance, hasKWalletAccountActive: true });
                    });
                }
            });
            spreeStore.dispatch(actions.displayLoader());
            UserUtils.subscribeToAssociateOrderLogin()
                .then(() => {
                    this.sendDataPaymentMethod();
                })
                .finally(() => {
                    spreeStore.dispatch(actions.hideLoader());
                });
        });
    }

    selectionToggle() {
        if (this.props.onOptionSelected) {
            this.props.onOptionSelected(this.props.method);
            this.sendDataPaymentMethod();
        }
    }

    sendDataPaymentMethod() {
        if (UserUtils.isLoggedIn()) {
            const { access_token: accessToken } = spreeStore.getState().auth;
            const { payment_methods: paymentMethods } = spreeStore.getState().order;
            const kwallet = paymentMethods.find((pm) => pm.attributes.type === 'Spree::Gateway::KwalletGateway');
            const formData = {
                order: {
                    payments_attributes: [
                        {
                            payment_method_id: kwallet.id,
                        },
                    ],
                },
                payment_source: {
                    [kwallet.id]: {
                        token_auth: accessToken,
                    },
                },
            };

            window.scrollTo(0, 0);
            spreeStore.dispatch(actions.displayLoader());
            spreeStore.dispatch(actions.goToNextStep(this.props.order, this.props.locale, formData, false))
                .finally(() => {
                    spreeStore.dispatch(actions.hideLoader());
                });
        }
    }

    isThisOptionSelected() {
        return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
    }

    shouldNextBeEnabled() {
        // add logic here to specify when next button should be enabled
        return UserUtils.isLoggedIn() && this.state.hasKWalletAccountActive && Number(this.state.availableBalance) >= Number(this.props.order.total);
    }

    render() {
        const signedInContent = (
            <div className={kwalletCss.pmKWalletWrapper__signedIn}>
                <div className={kwalletCss.pmKWalletWrapper__signedIn__colLeft}>
                    <div>
                        <img src={kwalletLogoImg} alt="K-Wallet logo" />
                    </div>
                    <div className={kwalletCss.pmKWalletWrapper__signedIn__description}>{this.props.method.description}</div>
                </div>
                <div className={kwalletCss.pmKWalletWrapper__signedIn__colRight}>
                    {this.state.hasKWalletAccountActive && (
                        <div>
                            <div className={kwalletCss.pmKWalletWrapper__signedIn__colRight__balanceSummary}>
                                <div className={kwalletCss.pmKWalletWrapper__signedIn__colRight__balanceSummary__colLabels}>
                                    <div style={{ fontSize: '17px', fontWeight: 'bolder' }}>
                                        <FormattedMessage id="manage-k-wallet-banner-account-balance" defaultMessage="Saldo actual:" />
                                    </div>
                                    <div style={{ fontSize: '16px' }}>
                                        <FormattedMessage id="manage-k-wallet-banner-available-balance" defaultMessage="Saldo disponible:" />
                                    </div>
                                </div>
                                <div className={kwalletCss.pmKWalletWrapper__signedIn__colRight__balanceSummary__colValues}>
                                    <div style={{ fontSize: '17px', fontWeight: 'bolder' }}>
                                        <span>{priceFormat.format(this.state.balance)}</span>
                                    </div>
                                    <div style={{ fontSize: '16px' }}>
                                        <span>{priceFormat.format(this.state.availableBalance)}</span>
                                    </div>
                                </div>
                            </div>
                            {Number(this.state.availableBalance) < Number(this.props.order.total) && (
                                <OverlayTrigger
                                    placement="bottom"
                                    shouldUpdatePosition
                                    overlay={(
                                        <Tooltip id={Math.random()}>
                                            <FormattedMessage id="manage-k-wallet-add-balance" defaultMessage="Clic para agregar fondos" />
                                        </Tooltip>
                                    )}
                                >
                                    <div
                                        className={kwalletCss.pmKWalletWrapper__signedIn__colRight__balance_insufficient}
                                        onClick={() => spreeStore.dispatch(push(APP_ROUTES.addFundsKWallet))}
                                    >
                                        <FormattedMessage
                                            id="manage-k-wallet-insufficient-balance"
                                            defaultMessage="SALDO INSUFICIENTE"
                                        />
                                    </div>
                                </OverlayTrigger>
                            )}
                        </div>
                    )}
                    {!this.state.hasKWalletAccountActive && (
                        <span style={{ fontSize: '16px' }}>
                            <FormattedHTMLMessage
                                id="k-wallet-account-not-active-yet"
                                defaultMessage="Su cuenta K-Wallet aun no se encuentra activa. Dirigete a 'Administrar K-Wallet' para activarla."
                            />
                        </span>
                    )}
                </div>
            </div>
        );

        const notSignedInContent = (
            <div className={kwalletCss.pmKWalletWrapper__notSignedIn}>
                <div className={kwalletCss.pmKWalletWrapper__notSignedIn__description}>
                    <div>
                        <img src={kwalletLogoImg} alt="K-Wallet logo" />
                    </div>
                    <div className={kwalletCss.pmKWalletWrapper__notSignedIn__description__text}>Para pagar con K-Wallet debes iniciar sesión</div>
                </div>
                <div className={`${signInFormCss.signin} ${kwalletCss.pmKWalletWrapper__notSignedIn__signInForm}`}>
                    <SignInForm
                        onSubmitCallback={(formData) => {
                            this.onSignIn(formData);
                        }}
                    />
                </div>
            </div>
        );
        return (
            <div>
                <div>
                    <input
                        type="radio"
                        id={this.props.method.id}
                        name="payment_method"
                        value={this.props.method.name}
                        onChange={() => {
                            this.selectionToggle();
                        }}
                        defaultChecked={this.props.method.isDefault}
                    />
                    <label className={generalCss.pms__option__label} htmlFor={this.props.method.id}>
                        {this.props.method.name}
                    </label>
                </div>
                {this.isThisOptionSelected() && LoaderUtils.isLoading()
                    && (
                        <div className="checkout-loading-container">
                            <FormattedMessage id="please-wait" defaultMessage="please wait" />
                            <Loader displayLoader size={36} />
                        </div>
                    )}

                {this.isThisOptionSelected() && !LoaderUtils.isLoading()
                    && <div style={{ padding: '25px' }}>{UserUtils.isLoggedIn() ? signedInContent : notSignedInContent}</div>}
            </div>
        );
    }
}

export default PaymentMethodKWallet;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment/payment-method-k-wallet.js
 **/